// native
import { Component, Input } from '@angular/core';

// models
import { ColorTestRecord } from 'app/models';

@Component({
    selector: 'app-color-circles',
    templateUrl: './color-circles.component.html',
    standalone: false
})
export class ColorCirclesComponent {

  @Input() colors: ColorTestRecord[] = [];
}
